import { useOperationalInformationTypes } from "features/CenterContent/shared/operationalInformation/hooks/useOperationalInformationTypes";
import { useTranslation } from "react-i18next";
import { ActionCard } from "shared/types/operationalInformation";
import { Nullish } from "shared/utils/objectUtils";

export const useLabelForActionCard = (actionCard: Nullish<ActionCard>) => {
  const { t } = useTranslation();

  const { data: operationalInformationTypes } =
    useOperationalInformationTypes(t);

  const actionCardLabel = actionCard
    ? operationalInformationTypes?.actionCards.find(
        (it) => it.type === actionCard.type,
      )?.label
    : undefined;

  return {
    actionCardLabel,
  };
};
